<template>
  <v-card>
    <v-card-title class="justify-center">
      <span v-if="form_type == 'addForm' " class="text-h5">{{ $t('Add Project') }}</span>
      <span v-if="form_type == 'editForm' " class="text-h5">{{ $t('Edit Project') }}</span>
      <span v-if="form_type == 'viewForm' " class="text-h5">{{ $t('Project Details') }}</span>
    </v-card-title>
      <v-container
        id="user-profile-view"
        fluid
        tag="section"
      >
        <v-row justify="center">
          <v-col
            cols="12"
            md="12"
          >
            <material-card
              color="primary"
              icon="mdi-application"
              class="mb-13"
            >
              <template #title>
                {{ $t('Project Information') }}
              </template>

              <v-form>
                <v-container class="py-0">

                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                    >
                      <v-select
                        v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type == 'planning'"
                        v-model="needSelected"
                        :items="projectNeedList"
                        :item-value="item=>item.id"
                        :label="$t('Project name and location')"
                        :hint="$t('Mandatory')"
                        :rules="selectRules"
                        persistent-hint
                      >
                        <template slot="selection" slot-scope="data">
                          {{ needSelectedName }}
                        </template>
                        <template v-slot:item="{ item }">
                          <div> {{ item.name_en }} </div>
                        </template>
                      </v-select>
                    </v-col>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                    >
                      <div v-if="form_type == 'viewForm' || phase_type =='planning_approval' || phase_type =='reporting' || phase_type =='completion'">
                        <p class="font-weight-light">{{ $t('Project name and location') }}</p>
                        <p class="text-h4 text--primary" v-if="project.project_need" >{{ project.project_need.name_en}}</p>

                      </div>
                    </v-col>
                  </v-row>

                  <v-row style="margin:0 !important;" v-if="form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion'">
                    <v-col 
                      cols="12" 
                      md="3"
                      sm="3"
                    >
                      <span class="font-weight-light">{{$t('Project Status')}}: </span>
                    </v-col>
                    <v-col 
                      cols="12"
                      md="3"
                      sm="3"
                    >
                      <span v-if="project.project_status">{{ getTranslation(project.project_status.translation.name) }}</span>
                    </v-col>
                  </v-row>
                  <v-row style="margin:0 !important;">
                    <v-col 
                      cols="12" 
                      md="3"
                      sm="3"
                    >
                      <span class="font-weight-light">{{$t('Description')}}: </span>
                    </v-col>
                    <v-col 
                      cols="12" 
                      md="3"
                      sm="3"
                    >
                      <span v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0)">{{ project.projectNeedInformation[0].description }}</span>
                      <span v-if="form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion'">
                        <span v-if="project.project_need">{{ project.project_need.description }}</span>
                      </span>
                    </v-col>
                  </v-row>
                  <v-row style="margin:0 !important;">
                    <v-col 
                      cols="12" 
                      md="3"
                      sm="3"
                    >
                      <span class="font-weight-light">{{$t('Need Submission Year')}}: </span>
                    </v-col>
                    <v-col 
                      cols="12" 
                      md="3"
                      sm="3"
                    >
                      <span v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0)">{{ project.projectNeedInformation[0].year.name }}</span>
                      <span v-if="form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion'">
                        <span v-if="project.project_need">{{ project.project_need.year.name }}</span>
                      </span>
                    </v-col>
                  </v-row>
                  <v-row style="margin:0 !important;">
                    <v-col 
                      cols="12" 
                      md="3"
                      sm="3"
                    >
                      <span class="font-weight-light">{{$t('Domain')}}: </span>
                    </v-col>
                    <v-col 
                      cols="12" 
                      md="3"
                      sm="3"
                    >
                      <span v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0)">{{ getTranslation(project.projectNeedInformation[0].domain.translation.name) }}</span>
                      <span v-if="form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion'">
                        <span v-if="project.project_need">{{ project.project_need.domain.translation.name }}</span>
                      </span>
                    </v-col>
                  </v-row>
                  <v-row style="margin:0 !important;">
                    <v-col 
                      cols="12" 
                      md="3"
                      sm="3"
                    >
                      <span class="font-weight-light">{{$t('Sector')}}: </span>
                    </v-col>
                    <v-col 
                      cols="12" 
                      md="3"
                      sm="3"
                    >
                      <span v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0)">{{ getTranslation(project.projectNeedInformation[0].project_sector.translation.name) }}</span>
                      <span v-if="form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion'">
                        <span v-if="project.project_need">{{ project.project_need.project_sector.translation.name }}</span>
                      </span>
                    </v-col>
                  </v-row>
                  <v-row style="margin:0 !important;">
                      <v-col 
                        cols="12" 
                        md="3"
                        sm="3"
                      >
                        <span class="font-weight-light">{{$t('Type of Investment')}}: </span>
                      </v-col>
                      <v-col 
                        cols="12" 
                        md="3"
                        sm="3"
                      >
                        <span v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0)">{{ getTranslation(project.projectNeedInformation[0].project_type.translation.name) }}</span>
                        <span v-if="form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion'">
                          <span v-if="project.project_need">{{ project.project_need.project_type.translation.name }}</span>
                       </span>
                    </v-col>
                  </v-row>

                  <v-row style="margin:0 !important;">
                      <v-col 
                        cols="12" 
                        md="3"
                        sm="3"
                      >
                        <span class="font-weight-light">{{$t('Event Type')}}: </span>
                      </v-col>
                      <v-col 
                        cols="12" 
                        md="3"
                        sm="3"
                      >
                        <span v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0 && project.projectNeedInformation[0].disaster_category)">{{ project.projectNeedInformation[0].disaster_category.translation.name }} </span>
                        <span v-if="form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion'">
                          <span v-if="project.project_need && project.project_need.disaster_category">{{ project.project_need.disaster_category.translation.name }}</span>
                       </span>
                    </v-col>
                  </v-row>
                  <v-row style="margin:0 !important;">
                      <v-col 
                        cols="12" 
                        md="3"
                        sm="3"
                      >
                        <span class="font-weight-light">{{$t('Event Year')}}: </span>
                      </v-col>
                      <v-col 
                        cols="12" 
                        md="3"
                        sm="3"
                      >
                        <span v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0 && project.projectNeedInformation[0].event_year !==null)">{{ project.projectNeedInformation[0].event_year.name }}</span>
                        <span v-if="form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion'">
                          <span v-if="project.project_need && project.project_need.event_year !==null">{{ project.project_need.event_year.name }}</span>
                       </span>
                    </v-col>
                  </v-row>

                  <v-row style="margin:0 !important;">
                      <v-col 
                        cols="12" 
                        md="3"
                        sm="3"
                      >
                        <span class="font-weight-light">{{$t('Cost (mLAK)')}}: </span>
                      </v-col>
                      <v-col 
                        cols="12" 
                        md="3"
                        sm="3"
                      >
                        <span v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0 && project.projectNeedInformation[0].cost !==null)">{{ project.projectNeedInformation[0].cost }}</span>
                        <span v-if="form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion'">
                          <span v-if="project.project_need && project.project_need.cost !==null">{{ project.project_need.cost }}</span>
                       </span>
                    </v-col>
                  </v-row>

                  <v-row style="margin:0 !important;">
                      <v-col 
                        cols="12" 
                        md="3"
                        sm="3"
                      >
                        <span class="font-weight-light">{{$t('Project Owner')}}: </span>
                      </v-col>
                      <v-col 
                        cols="12" 
                        md="3"
                        sm="3"
                      >
                        <span v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0)">{{ project.projectNeedInformation[0].project_owner.translation.name }}</span>
                        <span v-if="form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion'">
                          <span v-if="project.project_need">{{ project.project_need.project_owner.translation.name }}</span>
                        </span>
                    </v-col>
                  </v-row>

                  <v-row style="margin:0 !important;">
                      <v-col 
                        cols="12" 
                        md="3"
                        sm="3"
                      >
                        <span class="font-weight-light">{{$t('Project Owner Mail')}}: </span>
                      </v-col>
                      <v-col 
                        cols="12" 
                        md="3"
                        sm="3"
                      >
                        <span v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0)">{{ project.projectNeedInformation[0].contact_mail }}</span>
                        <span v-if="form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion'">
                          <span v-if="project.project_need">{{ project.project_need.contact_mail }}</span>
                        </span>
                      </v-col>
                  </v-row>

                  <v-row style="margin:0 !important;">
                      <v-col 
                        cols="12" 
                        md="3"
                        sm="3"
                      >
                        <span class="font-weight-light">{{$t('Project Owner Phone Number')}}: </span>
                      </v-col>
                      <v-col 
                        cols="12" 
                        md="3"
                        sm="3"
                      >
                        <span v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0)">{{ project.projectNeedInformation[0].contact_phone_number }}</span>
                        <span v-if="form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion'">
                            <span v-if="project.project_need">{{ project.project_need.contact_phone_number }}</span>
                        </span>
                      </v-col>
                  </v-row>

                  <v-row style="margin:0 !important;">
                    <v-col 
                      cols="12" 
                      md="3"
                      sm="3"
                    >
                      <span class="font-weight-light">{{$t('Project Owner Organization/Sector')}}: </span>
                    </v-col>
                    <v-col 
                      cols="12" 
                      md="3"
                      sm="3"
                    >
                        <div v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0)">
                        <span v-if="project.projectNeedInformation[0].organization === 'DPI' ">{{ getTranslation('DPI') }} {{ project.projectNeedInformation[0].province.translation.name }}</span>
                        <span v-if="project.projectNeedInformation[0].organization !== 'DPI'">{{ getTranslation(project.projectNeedInformation[0].project_owner.translation.name) }}</span>
                        </div>
                        <div v-if="form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion'">
                           <span v-if="project.project_need.organization === 'DPI'">{{ getTranslation('DPI') }} {{ project.project_need.province.translation.name }}</span>
                           <span v-if="project.project_need.organization !== 'DPI'">{{ getTranslation(project.project_need.project_owner.translation.name) }}</span>
                        </div>
                    </v-col>
                  </v-row>

                  <v-row style="margin:0 !important;">
                    <v-col 
                      cols="12"
                      md="3"
                      sm="3"
                    >
                        <span class="font-weight-light">{{$t('Province')}}: </span>
                    </v-col>
                    <v-col 
                      cols="12" 
                      md="3"
                      sm="3"
                    >
                        <span v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0 && project.projectNeedInformation[0].province !== null)">{{ project.projectNeedInformation[0].province.translation.name }}</span>
                        <span v-if="(form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion') && project.project_need && project.project_need.province !== null">
                          {{ project.project_need.province.translation.name }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col 
                      cols="12"
                      md="3"
                      sm="3"
                    >
                        <span class="font-weight-light">{{$t('District')}}: </span>
                    </v-col>
                    <v-col 
                      cols="12" 
                      md="9"
                      sm="9"
                    >   
                        <div v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0 && project.projectNeedInformation[0].project_need_districts.length !== 0)">
                          <span v-for="(dist,district_id) in project.projectNeedInformation[0].project_need_districts" :key="dist.district_id">{{ dist.district.translation.name }},</span>
                        </div>
                        <div v-if="(form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion') && project.project_need && project.project_need.project_need_districts && project.project_need.project_need_districts.length !== 0">
                            <span v-for="(dist,district_id) in project.project_need.project_need_districts" :key="dist.district_id">{{ dist.district.translation.name }},</span>
                        </div>

                        <!--V1-->
                        <!--<span v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0 && project.projectNeedInformation[0].district !== null)">{{ project.projectNeedInformation[0].district.translation.name }}</span>
                        <span v-if="(form_type == 'viewForm' || phaseType =='reporting' || phaseType =='completion') && project.project_need && project.project_need.district !== null">{{ project.project_need.district.translation.name }}</span>-->

                    </v-col>
                    <!--<v-col 
                      cols="12"
                      md="2"
                      sm="2"
                    >
                        <span class="font-weight-light">{{$t('Village')}}: </span>
                        </v-col>
                    <v-col 
                      cols="12" 
                      md="2"
                      sm="2"
                    >
                        <span v-if="(form_type == 'addForm' || form_type == 'editForm') && (project.projectNeedInformation && project.projectNeedInformation.length !== 0 && project.projectNeedInformation[0].village !== null)">{{ project.projectNeedInformation[0].village.translation.name }}</span>
                        <span v-if="(form_type == 'viewForm' || phaseType =='reporting' || phaseType =='completion') && project.project_need && project.project_need.village !== null">{{ project.project_need.village.translation.name }}</span>
                    </v-col>-->
                  </v-row>
                  <v-row style="margin:0 !important;" v-if="project.project_need && (form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion')">
                    <v-col 
                      cols="12" 
                      md="3"
                      sm="3"
                    >
                      <span class="font-weight-light">{{$t('Rehabilitation Plan Photos')}}: </span>
                    </v-col>
                    <v-col 
                      cols="12" 
                      md="3"
                      sm="3"
                    >
                      <div>
                        <v-row v-if="needPictures.length === 0">{{ $t('No Photos') }}</v-row>
                        <v-row v-if="needPictures.length !== 0">
                          <v-col v-for="(x,index) in needPictures" v-bind:key="index"
                            class="d-flex"
                            cols="12"
                            md="6"
                          >
                            <v-img style="max-height: 250px; object-fit: contain;" :src="needPictures[index].value" :lazy-src="needPictures[index].value" v-on:click="downloadPicture($store.state.projects.projectSelectedPlanPicture[index])" class="hyperlink_document"></v-img>
                          </v-col>
                          <v-col v-if="form_type == 'viewForm' && (needPictures.length !== project.project_need.project_need_pictures.length) "> {{ $t(' loading ... ') }}</v-col>
                        </v-row> 
                        <!--<v-row v-if="needPictures.length === 0">{{ $t('No Baseline Photos') }}</v-row>-->
                        <v-row v-if="form_type == 'viewForm' && needPictures.length === 0 && (needPictures.length !== project.project_need.project_need_pictures.length) ">{{ $t(' loading ... ') }}</v-row>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row style="margin:0 !important;" v-if="project.project_need && (form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion')">
                    <v-col 
                      cols="12" 
                      md="3"
                      sm="3"
                    >
                      <span class="font-weight-light">{{$t('Rehabilitation Plan Documents')}}: </span>
                    </v-col>
                    <v-col 
                      cols="12" 
                      md="9"
                      sm="9"
                    >
                    <v-row v-if="project.project_need.project_need_documents.length === 0">{{ $t('No Documents') }}</v-row>
                    <v-row class="hyperlink_document" v-for="(doc, index) in project.project_need.project_need_documents" :key="doc.id">
                        <v-col
                          cols="12"
                          md="12"
                        >
                        <span v-on:click="downloadPlanDocument(project.project_need.project_need_documents[index], null, null)">{{ project.project_need.project_need_documents[index].original_name }}</span> 
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>


                  <v-row  style="margin-top: 30px;">
                    <v-col 
                      cols="12" 
                      md="1"
                    >
                      <v-select
                          v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type == 'planning' "
                          v-model="project.project_mark_id"
                          :items="projectMarkList"
                          :item-value="item=>item.id"
                          :item-text="item=>item.name"
                          :label="$t('Rating')"
                          :hint="$t('Mandatory')"
                          :rules="selectRules"
                          persistent-hint
                        >
                          <template v-slot:item="{ item }">
                            <div>{{ item.name }}</div>
                          </template>
                      </v-select>
                      <div v-if="form_type == 'viewForm' || phase_type =='planning_approval' || phase_type =='reporting' || phase_type =='completion'">
                        <p class="font-weight-light">{{ $t('Rating') }}</p>
                        <p class="text-h4 text--primary"><span v-if="project.project_mark">{{ project.project_mark.name }}</span></p>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-menu
                        v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type =='planning'"
                        v-model="evaluationDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="evaluationDate"
                            :label="$t('Evaluation Certificate date')"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :hint="$t('Mandatory')"
                            :rules="dateRules"
                            persistent-hint
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="evaluationDate"
                          @input="evaluationDateMenu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                      <div v-if="form_type == 'viewForm' || phase_type =='planning_approval' || phase_type =='reporting' || phase_type =='completion'">
                        <p class="font-weight-light">{{ $t('Evaluation Certificate date') }}</p>
                        <p class="text-h4 text--primary">{{ new Date(project.evaluation_document_deadline).toLocaleDateString("en-GB") }}</p>
                      </div>
                    </v-col>
                    <v-col 
                      cols="12" 
                      md="2"
                    >
                      <v-text-field
                        v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type=='planning'"
                        v-model="estimationCost"
                        color="purple"
                        type="number"
                        :label="$t('Assessed Value (mLAK)')"
                        :hint="$t('Mandatory')"
                        :rules="numberRules"
                        persistent-hint
                      />
                      <div v-if="form_type == 'viewForm' || phase_type =='planning_approval' || phase_type =='reporting' || phase_type =='completion'">
                         <p class="font-weight-light">{{ $t('Assessed Value (mLAK)') }}</p>
                         <p class="text-h4 text--primary">{{ project.estimated_cost }}</p>
                      </div>
                    </v-col>
                    <v-col 
                      cols="12" 
                      md="2"
                    >
                      <p class="font-weight-light">{{ $t ('Cost Category') }}</p>
                      <p class="text-h4 text--primary" v-if="(form_type == 'addForm' || form_type == 'editForm') && projectClassInformation.length !== 0"> {{ getTranslation(projectClassInformation[0].translation.name) }}</p>
                      <p class="text-h4 text--primary" v-if="form_type == 'viewForm' || phase_type =='reporting' || phase_type =='completion' "> 
                        <span v-if="project.project_class">{{ getTranslation(project.project_class.translation.name) }}</span>
                      </p>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-menu
                        v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type =='planning_approval'"
                        v-model="startDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="startDate"
                            :label="$t('Start Date')"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :hint="$t('Mandatory')"
                            :rules="dateRules"
                            persistent-hint
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="startDate"
                          @input="startDateMenu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                      <div v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type =='planning_approval'"style="color: red;">
                        <span v-if="startDate > endDate">{{ $t('Inconsistent dates') }}</span> 
                      </div>
                      <div v-if="(form_type == 'viewForm' && phase_type ==='planning_approval') || phase_type =='reporting' || phase_type =='completion' || phase_type =='all' ">
                        <p class="font-weight-light">{{ $t('Start Date') }}</p>
                        <p class="text-h4 text--primary" v-if="project.project_start_date !== null">{{ new Date(project.project_start_date).toLocaleDateString("en-GB") }}</p>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-menu
                        v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type =='planning_approval'"
                        v-model="endDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="endDate"
                            :label="$t('End Date')"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :hint="$t('Mandatory')"
                            :rules="dateRules"
                            persistent-hint
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="endDate"
                          @input="endDateMenu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                      <div v-if="(form_type == 'viewForm' && phase_type ==='planning_approval') || phase_type =='reporting' || phase_type =='completion' || phase_type =='all'">
                        <p class="font-weight-light">{{ $t('End Date') }}</p>
                        <p class="text-h4 text--primary" v-if="project.project_end_date !== null">{{ new Date(project.project_end_date).toLocaleDateString("en-GB") }}</p>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-menu
                        v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type =='planning_approval'"
                        v-model="startPaymentDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="startPaymentDate"
                            :label="$t('Payment Start Date')"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :hint="$t('Mandatory')"
                            :rules="dateRules"
                            persistent-hint
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="startPaymentDate"
                          @input="startPaymentDateMenu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                      <div v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type =='planning_approval'"style="color: red;">
                        <span v-if="startPaymentDate > endPaymentDate">{{ $t('Inconsistent dates') }}</span> 
                      </div>
                      <div v-if="(form_type == 'viewForm' && phase_type ==='planning_approval') || phase_type =='reporting' || phase_type =='completion' || phase_type =='all'">
                        <p class="font-weight-light">{{ $t('Payment Start Date') }}</p>
                        <p class="text-h4 text--primary" v-if="project.payment_start_date !== null">{{ new Date(project.payment_start_date).toLocaleDateString("en-GB") }}</p>
                      </div>
                    </v-col>
                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-menu
                        v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type =='planning_approval'"
                        v-model="endPaymentDateMenu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="endPaymentDate"
                            :label="$t('Payment End Date')"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :hint="$t('Mandatory')"
                            :rules="dateRules"
                            persistent-hint
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="endPaymentDate"
                          @input="endPaymentDateMenu = false"
                        >
                        </v-date-picker>
                      </v-menu>
                      <div v-if="(form_type == 'viewForm' && phase_type ==='planning_approval') || phase_type =='reporting' || phase_type =='completion' || phase_type =='all'">
                        <p class="font-weight-light">{{ $t('Payment End Date') }}</p>
                        <p class="text-h4 text--primary" v-if="project.payment_end_date !== null">{{ new Date(project.payment_end_date).toLocaleDateString("en-GB") }}</p>
                      </div>
                    </v-col>
                  </v-row>

                  <v-row style="margin:0 !important;" v-if="phase_type !=='planning' ">
                    <v-col 
                      cols="12" 
                      md="2"
                    >
                      <v-text-field 
                        v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type =='planning_approval'"
                        color="purple"
                        :label="$t('Finance Sector ID')"
                        required
                        v-model="project.finance_sector_number"
                        :hint="$t('Mandatory')"
                        :rules="nameRules"
                        persistent-hint
                      ></v-text-field>

                      <div v-if="(form_type == 'viewForm' && phase_type ==='planning_approval') || phase_type =='reporting' || phase_type =='completion' || phase_type =='all'">
                        <span class="font-weight-light">{{$t('Finance Sector ID')}}: </span>
                        <span  v-if="project.finance_sector_number"> {{ project.finance_sector_number }}</span>
                      </div>
                    </v-col>

                    <v-col
                      cols="12"
                      md="2"
                    >
                      <v-text-field 
                        v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type =='planning_approval'"
                        color="purple"
                        :label="$t('Project ID')"
                        required
                        v-model="project.project_number"
                        :hint="$t('Mandatory')"
                        :rules="nameRules"
                        persistent-hint
                      ></v-text-field>

                      <div v-if="(form_type == 'viewForm' && phase_type ==='planning_approval') || phase_type =='reporting' || phase_type =='completion' || phase_type =='all'">
                        <span class="font-weight-light">{{$t('Project ID')}}: </span>
                        <span  v-if="project.project_number"> {{ project.project_number }}</span>
                      </div>
                    </v-col>

                    <v-col 
                      cols="12" 
                      md="2"
                    >
                      <v-text-field 
                          v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type =='planning_approval'"
                          color="purple"
                          :label="$t('Budget ID')"
                          required
                          v-model="project.budget_number"
                          :hint="$t('Mandatory')"
                          :rules="nameRules"
                          persistent-hint
                        ></v-text-field>

                        <div v-if="(form_type == 'viewForm' && phase_type ==='planning_approval') || phase_type =='reporting' || phase_type =='completion' || phase_type =='all'">
                          <span class="font-weight-light">{{$t('Budget ID')}}: </span>
                          <span v-if="project.budget_number"> {{ project.budget_number }}</span>
                        </div>
                    </v-col>

                  </v-row>



                  <v-row>
                    <v-col
                      cols="12"
                      md="12"
                      sm="12"
                    >
                      <v-text-field 
                        v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type =='planning' 
                                || (form_type == 'editForm' && phase_type =='planning_approval')
                                || (form_type == 'editForm' && phase_type =='reporting') 
                                || (form_type == 'editForm' && phase_type =='completion') "
                        color="purple"
                        :label="$t('Comments')"
                        required
                        v-model="project.comments"
                      ></v-text-field>
                      <div 
                        v-if="form_type == 'viewForm' ">
                        <p class="font-weight-light">{{ $t('Comments') }}</p>
                        <p class="text-h4 text--primary" v-if="project.comments !== null">{{ project.comments }}</p>
                        <p class="text-h4 text--primary" v-if="project.comments === null"> / </p>
                      </div>
                    </v-col>
                  </v-row>

                </v-container>
              </v-form>
            </material-card>

            <material-card
              color="primary"
              icon="mdi-application"
              class="mb-13"
            >
              <template #title>{{ $t('Social Impact') }}</template>

              <v-form>
                <v-container class="py-0">
                  <!--<v-row><span style="margin:auto;">{{ $t('Serviceability of asset') }}</span></v-row>-->
                  <v-row>
                    <v-col 
                      cols="12" 
                    >
                      <v-text-field
                        v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type=='planning'"
                        v-model="project.village_beneficiary_asset_vfm_number"
                        color="purple"
                        type="number"
                        :label="$t('Number of directly affected villages that the asset services:')"
                        :hint="$t('Positive Number is required')"
                        :rules="numberRules"
                        persistent-hint
                      />
                      <div v-if="form_type == 'viewForm' || phase_type =='planning_approval' || phase_type =='reporting' || phase_type =='completion'">
                        <p class="font-weight-light">{{ $t ('Number of directly affected villages that the asset services:') }}</p>
                        <p class="text-h4 text--primary">{{project.village_beneficiary_asset_vfm_number}}</p>
                        </div>
                    </v-col>
                  </v-row>
             
                  <v-row>
                    <v-col 
                      cols="12" 
                    >
                      <v-text-field
                        v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type=='planning'"
                        v-model="project.people_beneficiary_asset_vfm_number"
                        color="purple"
                        type="number"
                        :label="$t('Number of directly affected people that the asset services:')"
                        :hint="$t('Positive Number is required')"
                        :rules="numberRules"
                        persistent-hint
                      />
                     <div v-if="form_type == 'viewForm' || phase_type =='planning_approval' || phase_type =='reporting' || phase_type =='completion'">
                        <p class="font-weight-light">{{ $t ('Number of directly affected people that the asset services:') }}</p>
                        <p class="text-h4 text--primary">{{project.people_beneficiary_asset_vfm_number}}</p>
                      </div>
                       
                    </v-col>
                  </v-row> 
            
                  
                  <v-row>
                    <v-col 
                      cols="12" 
                    >
                      <v-text-field
                        v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type=='planning'"
                        v-model="project.people_poverty_vfm_percent"
                        color="purple"
                        type="number"
                        :label="$t('% of people in the district living below the poverty line:')"
                        :hint="$t('Positive Number is required')"
                        :rules="numberRules"
                        persistent-hint
                      />
                       <div v-if="form_type == 'viewForm' || phase_type =='planning_approval' || phase_type =='reporting' || phase_type =='completion'">
                        <p class="font-weight-light">{{ $t ('% of people in the district living below the poverty line:') }}</p>
                        <p class="text-h4 text--primary">{{project.people_poverty_vfm_percent}}</p>
                        </div>
                    </v-col>
                  </v-row>

                  </v-container>
                </v-form>
              </material-card>

              <material-card
                color="primary"
                icon="mdi-application"
                class="mb-13"
                 v-if="phase_type == 'all' || phase_type === 'reporting' || (phase_type === 'planning_approval' && project.contractor !== null)"
              >
              <template #title>{{ $t('Contractor') }}</template>

              <v-form>
                <v-container class="py-0">

                  <v-row v-if="phase_type == 'all' || phase_type === 'reporting'">
                    <v-col 
                      cols="12" 
                    >
                      <div v-if="project.contractor !== null">
                        <v-col cols="12" class="font-weight-light">{{$t('Contractor Name')}}: <span class="font-weight-medium">{{ project.contractor.name }}</span></v-col>
                        <v-col cols="12" class="font-weight-light">{{$t('Primary Contact and Position')}}: <span class="font-weight-medium">{{ project.contractor.contact }}, {{ project.contractor.position }}</span></v-col>
                        <v-col cols="12" class="font-weight-light">{{$t('Contractor Address')}}: <span class="font-weight-medium">{{ project.contractor.address }}</span></v-col>
                        <v-col cols="12" class="font-weight-light">{{$t('Province')}}: <span class="font-weight-medium">{{ project.contractor.province.translation.name }}</span></v-col>
                        <v-col cols="12" class="font-weight-light">{{$t('Phone Number')}}: <span class="font-weight-medium">{{ project.contractor.phone_number }}</span></v-col>
                        <v-col cols="12" class="font-weight-light">{{$t('Experience - Demonstrated experience of successfully completing projects of similar size and scope in Lao PDR')}}: <span class="font-weight-medium">{{ getTranslation(project.contractor.contractor_experience.translation.name) }}</span></v-col>
                        <v-col cols="12" class="font-weight-light">{{$t('Number of Project < 20 bLAK')}}: <span class="font-weight-medium">{{ project.contractor.number_project_under_20 }} {{$t('Projects')}}</span></v-col>
                        <v-col cols="12" class="font-weight-light">{{$t('Number of Project > 20 bLAK')}}: <span class="font-weight-medium">{{ project.contractor.number_project_above_20 }} {{$t('Projects')}}</span></v-col> 
                      </div> 
                      <div v-if="project.contractor === null">{{$t('No Contractor')}}</div>
                    </v-col>
                  </v-row>

                </v-container>
                </v-form>
              </material-card>

              <material-card
                color="primary"
                icon="mdi-application"
                class="mb-13"
              >
              <template #title>{{ $t('Photos') }}</template>

              <v-form>
                <v-container class="py-0">

                  <!----------------------------------  BASELINE PICTURE ------------------------------------------------------>
                  <v-row v-if="phase_type == 'planning' || phase_type == 'planning_approval' || phase_type === 'reporting' || phase_type == 'completion' || phase_type == 'all'">
                      <span style="margin: auto;">{{ $t('Baseline Photos') }}</span>
                  </v-row> 
                  <v-row v-if="phase_type=='planning'" style="display: flex;align-items: center;justify-content: center;"> 
                    <v-file-input multiple v-if="form_type == 'addForm' || form_type == 'editForm'" :label="$t('Insert Baseline Photos')" v-model="project.project_baseline_pictures">
                      <template slot="append"> {{ project.project_baseline_pictures }}</template>
                    </v-file-input>
                  </v-row> 

                  <div v-if="phase_type == 'planning' || phase_type == 'planning_approval' || phase_type === 'reporting' || phase_type == 'completion' || phase_type == 'all'">
                    <v-row v-if="baselinePictures.length !== 0">
                      <v-col v-for="(x,index) in baselinePictures" v-bind:key="index"
                        class="d-flex"
                        cols="12"
                        sm="4"
                      >
                        <v-img style="max-height: 250px; object-fit: contain;" :src="baselinePictures[index].value" :lazy-src="baselinePictures[index].value" v-on:click="downloadPicture($store.state.projects.projectSelectedApplicationPicture[index])" class="hyperlink_document"></v-img>
                        <v-btn v-if="form_type == 'editForm'"
                          style="color:grey;background-color: transparent;"
                          class="delete-button rounded-circle"
                          v-on:click="deletePicture($store.state.projects.projectSelectedApplicationPicture[index])"
                        > x </v-btn>  
                      </v-col>
                      <v-col v-if="form_type == 'viewForm' && (baselinePictures.length !== project.baseline_pictures.length) "> {{ $t(' loading ... ') }}</v-col>
                    </v-row> 
                    <!--<v-row v-if="baselinePictures.length === 0">{{ $t('No Baseline Photos') }}</v-row>-->
                    <v-row v-if="form_type == 'viewForm' && baselinePictures.length === 0 && (baselinePictures.length !== project.baseline_pictures.length) ">{{ $t(' loading ... ') }}</v-row>
                  </div>

                  <!----------------------------------  REPORTING PICTURE ------------------------------------------------------>
                  <v-row v-if="phase_type=='reporting' || phase_type=='completion' || phase_type == 'all'"><span style="margin: auto;">{{ $t('Work Reporting Photos') }}</span></v-row> 
                  <v-row v-if="phase_type=='reporting'" style="display: flex;align-items: center;justify-content: center;"> 
                    <v-file-input multiple v-if="form_type == 'editForm' && (project.project_completion_document_list && project.project_completion_document_list.length === 0) && !display_completion_reporting_container" :label="$t('Insert Work Reporting Photos')" v-model="project.project_reporting_pictures">
                      <template slot="append"> {{ project.project_reporting_pictures }}</template>
                    </v-file-input>
                  </v-row> 

                  <v-row v-if="reportingPictures.length !== 0">
                      <v-col v-for="(x,index) in reportingPictures" v-bind:key="index"
                        class="d-flex"
                        cols="12"
                        sm="4"
                      >
                        <v-img style="max-height: 250px; object-fit: contain;" :src="reportingPictures[index].value" :lazy-src="reportingPictures[index].value" v-on:click="downloadPicture($store.state.projects.projectSelectedReportingPicture[index])" class="hyperlink_document"></v-img>
                        <v-btn v-if="form_type == 'editForm'"
                          style="color:grey;background-color: transparent;"
                          class="delete-button rounded-circle"
                          v-on:click="deletePicture($store.state.projects.projectSelectedReportingPicture[index])"
                        > x </v-btn>
                      </v-col>
                      <v-col v-if="reportingPictures && (reportingPictures.length !== project.reporting_pictures.length) "> {{ $t(' loading ... ') }}</v-col>
                  </v-row> 
                  <!--<v-row v-if="phase_type=='reporting' 
                                && form_type !== 'editForm'
                                && reportingPictures.length === 0">
                              {{ $t('No Work Reporting Photos') }}
                  </v-row>-->
                  <v-row v-if="phase_type=='reporting' && form_type !== 'editForm' && reportingPictures.length === 0 && (reportingPictures.length !== project.reporting_pictures.length) ">{{ $t(' loading ... ') }}</v-row>

                  <!----------------------------------  COMPLETION PICTURE ------------------------------------------------------>
                  <div v-if="phase_type == 'completion' || phase_type == 'all' ">

                    <div v-if="project.project_reportings.length === 3 
                              && (display_completion_reporting_container || phase_type=='completion' || (project.project_completion_document_list && project.project_completion_document_list.length !== 0))" >
                      <v-row><span style="margin: auto;">{{ $t('Work Completion Photos') }}</span></v-row>

                      <v-row v-if="display_completion_reporting_container" style="display: flex;align-items: center;justify-content: center;"> 
                        <v-file-input multiple v-if="form_type == 'editForm'" :label="$t('Insert Work Completion Photos')" v-model="project.project_completion_pictures">
                          <template slot="append"> {{ project.project_completion_pictures }} </template>
                        </v-file-input>
                      </v-row>

                      <v-row v-if="completionPictures && completionPictures.length !== 0">
                          <v-col v-for="(x,index) in completionPictures" v-bind:key="index"
                            class="d-flex"
                            cols="12"
                            sm="4"
                          >
                            <v-img style="max-height: 250px; object-fit: contain;" :src="completionPictures[index].value" :lazy-src="completionPictures[index].value" v-on:click="downloadPicture($store.state.projects.projectSelectedCompletionPicture[index])" class="hyperlink_document"></v-img>
                            <v-btn v-if="form_type == 'editForm'"
                              style="color:grey;background-color: transparent;"
                              class="delete-button rounded-circle"
                              v-on:click="deletePicture($store.state.projects.projectSelectedCompletionPicture[index])"
                            > x </v-btn>
                          </v-col>
                          <v-col v-if="completionPictures && (completionPictures.length !== project.completion_pictures.length) "> {{ $t(' loading ... ') }}</v-col>
                      </v-row>

                      <!--<v-row v-if="completionPictures && completionPictures.length === 0">
                              {{ $t('No Work Completion Photos') }}
                      </v-row>-->
                      <v-row v-if="completionPictures && completionPictures.length === 0 && (completionPictures.length !== project.completion_pictures.length) ">{{ $t(' loading ... ') }}</v-row>

                    </div>

                  </div>
                  
                </v-container>
              </v-form>
            </material-card>




        <!--<material-card
          color="primary"
          icon="mdi-currency-usd"
          v-if="phaseType=='completion' || phaseType == 'all' "
        >
          <template #title> {{ $t('Value For Money') }} </template>

          <v-form>
            <v-container class="py-0">

              <v-row><span style="margin: auto;">{{ $t('Rapid rebuilding of people\'s livelihoods') }}</span></v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="form_type=='editForm'"
                    :label="$t('Number of directly affected villages that the asset services:')"
                    v-model="project.village_beneficiary_asset_completion_number"
                  />
                  <div v-if="form_type=='viewForm'">
                    <h3 class="font-weight-regular">{{ $t('Number of directly affected villages that the asset services:')}} 
                      <span v-if="project.village_beneficiary_asset_completion_number !== null">{{ project.village_beneficiary_asset_completion_number }}</span>
                      <span v-else> 0 </span>
                    </h3>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="form_type=='editForm'"
                    :label="$t('Number of directly affected people that the asset services:')"
                    v-model="project.people_beneficiary_asset_completion_number"
                  />
                  <div v-if="form_type=='viewForm'">
                    <h3 class="font-weight-regular">{{ $t('Number of directly affected people that the asset services:')}} 
                      <span v-if="project.people_beneficiary_asset_completion_number !== null">{{ project.people_beneficiary_asset_completion_number }}</span>
                      <span v-else> 0 </span>
                    </h3>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="form_type=='editForm'"
                    :label="$t('% of people in the district living below the poverty line:')"
                    v-model="project.people_poverty_completion_percent"
                  />
                  <div v-if="form_type=='viewForm'">
                    <h3 class="font-weight-regular">{{ $t('% of people in the district living below the poverty line:')}} 
                      <span v-if="project.people_poverty_completion_percent !== null">{{ project.people_poverty_completion_percent }}</span>
                      <span v-else> 0 </span>
                    </h3>
                  </div>
                </v-col>
              </v-row>

              <v-row><span style="margin: auto;">{{ $t('Local industry & community participation') }}</span></v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="form_type=='editForm'"
                    :label="$t('Number of directly affected villages consulted')"
                    v-model="project.affected_village_consulted_completion_number"
                  />
                  <div v-if="form_type=='viewForm'">
                    <h3 class="font-weight-regular">{{ $t('Number of directly affected villages consulted')}}: 
                      <span v-if="project.affected_village_consulted_completion_number !== null">{{ project.affected_village_consulted_completion_number }}</span>
                      <span v-else> 0 </span>
                    </h3>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="form_type=='editForm'"
                    :label="$t('Number of directly affected people consulted')"
                    v-model="project.affected_people_consulted_completion_number"
                  />
                  <div v-if="form_type=='viewForm'">
                    <h3 class="font-weight-regular">{{ $t('Number of directly affected people consulted')}}: 
                    <span v-if="project.affected_people_consulted_completion_number !== null">{{ project.affected_people_consulted_completion_number }}</span>
                    <span v-else> 0 </span>
                  </h3>
                  </div>
                </v-col>
              </v-row>              
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="form_type=='editForm'"
                    :label="$t('Number of directly affected women consulted')"
                    v-model="project.affected_woman_consulted_completion_number"
                  />
                  <div v-if="form_type=='viewForm'">
                    <h3 class="font-weight-regular">{{ $t('Number of directly affected women consulted')}}: 
                    <span v-if="project.affected_woman_consulted_completion_number !== null">{{ project.affected_woman_consulted_completion_number }}</span>
                    <span v-else> 0 </span>
                  </h3>
                  </div>
                </v-col>
              </v-row>              
              <v-row>
                <v-col cols="12" md="12" >
                  <h3 class="font-weight-regular"> {{ $t('Local registered contractor (ie ... with head office location in Province)') }}</h3>
                  <v-radio-group inline v-if="form_type=='editForm'" v-model="project.registered_local_contractor_completion">
                    <v-radio :label="$t('Yes')" v-bind:value="true"></v-radio>
                    <v-radio :label="$t('No')" v-bind:value="false"></v-radio>
                  </v-radio-group>
                  <div v-if="form_type=='viewForm'">
                      <p class="font-weight-regular">
                        <span v-if="project.registered_local_contractor_completion === true">{{$t('Yes')}}</span>
                        <span v-if="project.registered_local_contractor_completion === false">{{$t('No')}}</span>
                        <span v-if="project.registered_local_contractor_completion === null"> / </span>
                      </p>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="form_type=='editForm'"
                    :label="$t('Number of local full-time staff')"
                    v-model="project.full_staff_number_completion"
                  />
                  <div v-if="form_type=='viewForm'">
                    <h3 class="font-weight-regular">{{ $t('Number of local full-time staff')}}: 
                      <span v-if="project.full_staff_number_completion !== null">{{ project.full_staff_number_completion }}</span>
                      <span v-else> 0 </span>
                    </h3>
                  </div>
                </v-col>
              </v-row>              
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="form_type=='editForm'"
                    :label="$t('Number of local full-time women staff')"
                    v-model="project.woman_full_staff_number_completion"
                  />
                  <div v-if="form_type=='viewForm'">
                    <h3 class="font-weight-regular">{{ $t('Number of local full-time women staff')}}: 
                      <span v-if="project.woman_full_staff_number_completion !== null">{{ project.woman_full_staff_number_completion }}</span>
                      <span v-else> 0 </span>
                    </h3>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="form_type=='editForm'"
                    :label="$t('Number of locally hired temporary labour-days')"
                    v-model="project.temporary_staff_number_day_completion"
                  />
                  <div v-if="form_type=='viewForm'">
                    <h3 class="font-weight-regular">{{ $t('Number of locally hired temporary labour-days')}}: 
                      <span v-if="project.temporary_staff_number_day_completion !== null">{{ project.temporary_staff_number_day_completion }}</span>
                      <span v-else> 0 </span>
                    </h3>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <v-text-field
                    color="purple"
                    v-if="form_type=='editForm'"
                    :label="$t('Number of locally hired temporary labour-days (women)')"
                    v-model="project.temporary_staff_women_percent_completion"
                  />
                  <div v-if="form_type=='viewForm'">
                    <h3 class="font-weight-regular">{{ $t('Number of locally hired temporary labour-days (women)')}}: 
                      <span v-if="project.temporary_staff_women_percent_completion !== null">{{ project.temporary_staff_women_percent_completion }}</span>
                      <span v-else> 0 </span>
                    </h3>
                  </div>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="12" >
                  <h3 class="font-weight-regular"> {{ $t('Will the majority of material be locally sourced') }}</h3>
                  <v-radio-group inline v-if="form_type=='editForm'" v-model="project.majority_local_material_completion">
                    <v-radio :label="$t('Yes')" v-bind:value="true"></v-radio>
                    <v-radio :label="$t('No')" v-bind:value="false"></v-radio>
                  </v-radio-group>
                  <div v-if="form_type=='viewForm' ">
                      <p class="font-weight-regular">
                        <span v-if="project.majority_local_material_completion === true">{{$t('Yes')}}</span>
                        <span v-if="project.majority_local_material_completion === false">{{$t('No')}}</span>
                        <span v-if="project.majority_local_material_completion === null"> / </span>
                      </p>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <h3 class="font-weight-regular"> {{ $t('Will the majority of machinery be locally sourced') }}</h3>
                  <v-radio-group inline v-if="form_type=='editForm'" v-model="project.majority_local_machinery_completion">
                    <v-radio :label="$t('Yes')" v-bind:value="true"></v-radio>
                    <v-radio :label="$t('No')" v-bind:value="false"></v-radio>
                  </v-radio-group>
                     
                  <div v-if="form_type=='viewForm'">
                      <p class="font-weight-regular">
                        <span v-if="project.majority_local_machinery_completion === true">{{$t('Yes')}}</span>
                        <span v-if="project.majority_local_machinery_completion === false">{{$t('No')}}</span>
                        <span v-if="project.majority_local_machinery_completion === null"> / </span>
                      </p>
                  </div>
             
                </v-col>
              </v-row>

              <v-row><span style="margin: auto;">{{ $t('Design Quality & Development Gains') }}</span></v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <h3 class="font-weight-regular"> {{ $t('Has the asset been maintained to a service level in the past 12 months ?') }}</h3>
                  <v-radio-group inline v-if="form_type=='editForm'" v-model="project.serviceable_level_maintained_completion">
                    <v-radio :label="$t('Yes')" v-bind:value="true"></v-radio>
                    <v-radio :label="$t('No')" v-bind:value="false"></v-radio>
                  </v-radio-group>
                     
                  <div v-if="form_type=='viewForm'">
                      <p class="font-weight-regular">
                        <span v-if="project.serviceable_level_maintained_completion === true">{{$t('Yes')}}</span>
                        <span v-if="project.serviceable_level_maintained_completion === false">{{$t('No')}}</span>
                        <span v-if="project.serviceable_level_maintained_completion === null"> / </span>
                      </p>
                  </div>
                </v-col>
              </v-row>
               <v-row>
                <v-col cols="12" md="12" >
                  <h3 class="font-weight-regular">{{ $t('Has natural hazard risk assessment been completed ?') }}</h3>
                  <v-radio-group inline v-if="form_type=='editForm'" v-model="project.environmental_risk_assessment_completed_completion">
                    <v-radio :label="$t('Yes')" v-bind:value="true"></v-radio>
                    <v-radio :label="$t('No')" v-bind:value="false"></v-radio>
                  </v-radio-group>
                   
                  <div v-if="form_type=='viewForm'">
                      <p class="font-weight-regular">
                        <span v-if="project.environmental_risk_assessment_completed_completion === true">{{$t('Yes')}}</span>
                        <span v-if="project.environmental_risk_assessment_completed_completion === false">{{$t('No')}}</span>
                        <span v-if="project.environmental_risk_assessment_completed_completion === null"> / </span>
                      </p>
                  </div>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" >
                  <h3 class="font-weight-regular">{{ $t('Has environmental social and safeguard process been completed ?') }}</h3>
                  <v-radio-group inline v-if="form_type=='editForm'" v-model="project.grievance_established_completion">
                    <v-radio :label="$t('Yes')" v-bind:value="true"></v-radio>
                    <v-radio :label="$t('No')" v-bind:value="false"></v-radio>
                  </v-radio-group>
                  
                  <div v-if="form_type=='viewForm'">
                      <p class="font-weight-regular">
                        <span v-if="project.grievance_established_completion === true">{{$t('Yes')}}</span>
                        <span v-if="project.grievance_established_completion === false">{{$t('No')}}</span>
                        <span v-if="project.grievance_established_completion === null"> / </span>
                      </p>
                  </div>

                </v-col>
              </v-row>

            </v-container>
          </v-form>
        </material-card>-->



        <material-card
              color="primary"
              icon="mdi-application"
            >
              <template #title>{{ $t('Project Document') }}</template>

              <v-form>
                <v-container class="py-0">

                  <!------------------------------------------ PROJECT INSTRUCTION ------------------------------------------------------------------------->
                  <v-row v-if="phase_type == 'planning' || phase_type == 'planning_approval' || phase_type === 'reporting' || phase_type == 'completion' || phase_type == 'all' ">
                      <span style="margin:auto;font-weight: bold;">{{ $t('Project Instruction Document') }}</span>
                  </v-row>
                  <v-row v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type == 'planning' "> 
                    <v-data-table style="margin:auto;"
                      class="v-data-table-document"
                      :headers="documentHeaders"
                      :items="project.project_instruction_documents" 
                    > <!--:items="project.project_instruction_documents" -->

                      <template v-for="header in documentHeaders" v-slot:[`header.${header.value}`]="{ header }">
                        <span>{{ getHeader(header.text) }}</span>
                      </template>
                      <template v-slot:item.document="{ item }">
                        <v-file-input
                          :label="item.name"
                          v-model="applicationDocuments[item.id-1]"
                        >
                        <!--<v-file-input 
                          :label="item.name"
                          v-model="project.project_instruction_documents[item.id-1]"
                        >-->
                        <template slot="append">{{ project.project_instruction_documents[item.id-1].original_name }}</template>
                        </v-file-input>
                      </template>
                      <template v-slot:item.updatetime="{ item }">
                        <span
                          text class="align-items--right"
                          min-width="200px"
                          v-if="item.updatedAt"
                        > 
                            {{ new Date(item.updatedAt).toLocaleDateString("en-GB") }}
                        </span>
                      </template>
                      <template v-slot:item.missing_document="{ item }">
                          <span
                            text class="align-items--right"
                            min-width="200px"
                          >
                              <span class="missing-document-label" v-if="item.original_name === 'No Document' ">{{ getTranslation('Missing Document') }}</span>
                          </span>
                        </template>
                    </v-data-table>
                  </v-row> 

                  <v-row v-if=" phase_type == 'planning_approval' || 
                                (form_type=='viewForm' && phase_type == 'planning') || phase_type === 'reporting' || phase_type == 'completion' || phase_type == 'all' ">
                    <v-data-table style="margin:auto;"
                      class="v-data-table"
                      :headers="documentHeaders"
                      :items="project.project_instruction_documents" 
                    >
                      <template v-for="header in documentHeaders" v-slot:[`header.${header.value}`]="{ header }">
                        <span>{{ getHeader(header.text) }}</span>
                      </template>
                      <template v-slot:item.document="{ item }">
                        <span
                          text class="align-items--right"
                          min-width="200px"
                        > 
                            <span class="font-weight-black"> {{ getTranslation(item.name) }} </span> : <span class="hyperlink_document" v-on:click="download(item.original_name, project.id, null)">{{ item.original_name }}</span>
                        </span>
                      </template>
                      <template v-slot:item.updatetime="{ item }">
                        <span
                          text class="align-items--right"
                          min-width="200px"
                          v-if="item.updatedAt"
                        > 
                            {{ new Date(item.updatedAt).toLocaleDateString("en-GB") }}
                        </span>
                      </template>
                      <template v-slot:item.missing_document="{ item }">
                          <span
                            text class="align-items--right"
                            min-width="200px"
                          >
                              <span class="missing-document-label" v-if="item.original_name === 'No Document' ">{{ getTranslation('Missing Document') }}</span>
                          </span>
                        </template>

                    </v-data-table>
                  </v-row>







                  <!------------------------------------------ PROJECT REPORTING ------------------------------------------------------------------------->
                  <div v-for="(reporting, index) in project.project_reporting_documents">
                    <v-row v-if="phase_type === 'reporting' || phase_type == 'completion' || phase_type == 'all' ">
                      <span style="margin:auto;font-weight: bold;">{{ $t('Project Reporting Document') }}: {{ reporting.name }} 
                        <!--(<v-icon v-if="reporting.validated" color="success">mdi-check</v-icon> <v-icon color="error" v-if="!reporting.validated">mdi-close</v-icon>) -->
                      </span> 
                    </v-row> 

                    <!--ADD/EDITION-->
                    <v-row v-if="(form_type == 'addForm' || form_type == 'editForm') && phase_type == 'reporting' "> 
                      <v-data-table style="margin:auto;"
                        class="v-data-table-document"
                        :headers="documentHeaders"
                        :items="reporting.reporting_documents" 
                      >
                        <template v-for="header in documentHeaders" v-slot:[`header.${header.value}`]="{ header }">
                          <span>{{ getHeader(header.text) }}</span>
                        </template>
                        <template v-slot:item.document="{ item, index }">
                          <span v-if="reporting.validated"
                            text class="align-items--right"
                            min-width="200px"
                          >   
                              <span class="font-weight-black">{{ getTranslation(item.name) }} </span> : {{ item.original_name }}
                          </span>

                          <v-file-input 
                              v-if="!reporting.validated" 
                              :label="item.document_category.translation.name" 
                              v-model="reportingDocuments[index]"
                          >
                            <template slot="append"> {{ reporting.reporting_documents[index].original_name }}</template>               
                          </v-file-input>
                        </template>

                        <template v-slot:item.updatetime="{ item }">
                          <span 
                            text class="align-items--right"
                            min-width="200px"
                            v-if="item.updatedAt"
                          > 
                              {{ new Date(item.updatedAt).toLocaleDateString("en-GB") }}
                          </span>
                        </template>
                        <template v-slot:item.missing_document="{ item }">
                            <span
                              text class="align-items--right"
                              min-width="200px"
                            >
                                <span class="missing-document-label" v-if="item.original_name === 'No Document' ">{{ getTranslation('Missing Document') }}</span>
                            </span>
                          </template>
                      </v-data-table>
                    </v-row> 

                    <!--VIEW-->
                    <v-row v-if="(form_type=='viewForm' && phase_type === 'reporting') || phase_type == 'completion' || phase_type == 'all' ">
                      <v-data-table style="margin:auto;"
                        class="v-data-table-document"
                        :headers="documentHeaders"
                        :items="reporting.reporting_documents" 
                      >
                        <template v-for="header in documentHeaders" v-slot:[`header.${header.value}`]="{ header }">
                          <span>{{ getHeader(header.text) }}</span>
                        </template>
                        <template v-slot:item.document="{ item }">

                          <span
                            text class="align-items--right"
                            min-width="200px"
                          >   
                            <span class="font-weight-black">{{ getTranslation(item.name) }} </span> : <span class="hyperlink_document" v-on:click="download(item.original_name, project.id, item.reporting_id)">{{ item.original_name }}</span>
                          </span>
                        </template>
                        <template v-slot:item.updatetime="{ item }">
                          <span
                            text class="align-items--right"
                            min-width="200px"
                            v-if="item.updatedAt"
                          > 
                              {{ new Date(item.updatedAt).toLocaleDateString("en-GB") }}
                          </span>
                        </template>
                        <template v-slot:item.missing_document="{ item }">
                            <span
                              text class="align-items--right"
                              min-width="200px"
                            >
                                <span class="missing-document-label" v-if="item.original_name === 'No Document' ">{{ getTranslation('Missing Document') }}</span>
                            </span>
                          </template>

                      </v-data-table>
                    </v-row>
                  </div>

                  <div class="add-button-new-reporting-container">
                    <v-btn
                        v-if="(form_type == 'addForm' || form_type == 'editForm') 
                            && phase_type == 'reporting'
                            && display_create_new_reporting_button 
                            && ($store.state.auth.user.user_functions[2].user_type_id !== 1
                               || $store.state.auth.user.user_functions[4].user_type_id !== 1
                               || $store.state.auth.user.user_functions[5].user_type_id !== 1
                               || $store.state.auth.user.user_functions[8].user_type_id !== 1)
                           "
                      class="add-button-new-reporting"
                      text
                      v-on:click="createNewReporting()"
                    >
                    {{ $t('Add New Project Reporting') }}
                  </v-btn>
                  <v-btn
                        v-if="(form_type == 'addForm' || form_type == 'editForm') 
                            && phase_type == 'reporting'
                            && display_create_completion_reporting_button 
                            && ($store.state.auth.user.user_functions[2].user_type_id !== 1
                               || $store.state.auth.user.user_functions[4].user_type_id !== 1
                               || $store.state.auth.user.user_functions[5].user_type_id !== 1
                               || $store.state.auth.user.user_functions[8].user_type_id !== 1)
                           "
                      class="add-button-new-reporting"
                      text
                      v-on:click="createNewCompletionReporting()"
                    >
                    {{ $t('Add Project Completion Reporting') }}
                  </v-btn>
                  </div>

                  <!------------------------------------------ PROJECT COMPLETION ------------------------------------------------------------------------->
                  <div v-if="display_completion_reporting_container">
                    <v-row>
                      <span style="margin:auto;font-weight: bold;">{{ $t('Project Completion Document') }}</span>  
                    </v-row>
                    <v-row v-if="(form_type == 'addForm' || form_type == 'editForm') "> 
                      <v-data-table style="margin:auto;"
                        class="v-data-table-document"
                        :headers="documentHeaders"
                        :items="project.project_completion_documents" 
                      >
                        <template v-for="header in documentHeaders" v-slot:[`header.${header.value}`]="{ header }">
                          <span>{{ getHeader(header.text) }}</span>
                        </template>
                        <template v-slot:item.document="{ item }">
                          <v-file-input
                            :label="item.name"
                            v-model="completionDocuments[item.id-1]"
                          >
                          <template slot="append">{{ project.project_completion_documents[item.id-1].original_name }}</template>
                          </v-file-input>
                        </template>
                        <template v-slot:item.updatetime="{ item }">
                            <span 
                              text class="align-items--right"
                              min-width="200px"
                              v-if="item.updatedAt"
                            > 
                                {{ new Date(item.updatedAt).toLocaleDateString("en-GB") }}
                            </span>
                          </template>
                          <template v-slot:item.missing_document="{ item }">
                              <span
                                text class="align-items--right"
                                min-width="200px"
                              >
                                  <span class="missing-document-label" v-if="item.original_name === 'No Document' ">{{ getTranslation('Missing Document') }}</span>
                              </span>
                            </template>
                      </v-data-table>
                    </v-row> 
                  </div>
                  <div v-if="(project.project_reportings 
                              && project.project_reportings.length === 3 
                              && !display_completion_reporting_container 
                              && project.project_completion_document_list 
                              && project.project_completion_document_list.length !== 0
                              && phase_type == 'reporting')
                              || phase_type == 'completion'
                              || (phase_type == 'all' 
                                  && project.project_completion_document_list 
                                  && project.project_completion_document_list.length !== 0)">
                    <v-row>
                      <span style="margin:auto;font-weight: bold;">{{ $t('Project Completion Document') }}</span>  
                    </v-row>
                    <v-row>
                      <v-data-table style="margin:auto;"
                        class="v-data-table-document"
                        :headers="documentHeaders"
                        :items="project.project_completion_documents" 
                      >
                        <template v-for="header in documentHeaders" v-slot:[`header.${header.value}`]="{ header }">
                          <span>{{ getHeader(header.text) }}</span>
                        </template>
                        <template v-slot:item.document="{ item }">
                          <span
                            text class="align-items--right"
                            min-width="200px"
                          > 
                              <span class="font-weight-black">{{ getTranslation(item.name) }} </span> : <span class="hyperlink_document" v-on:click="download(item.original_name, project.id, null)">{{ item.original_name }}</span>
                          </span>
                        </template>
                        <template v-slot:item.updatetime="{ item }">
                          <span
                            text class="align-items--right"
                            min-width="200px"
                            v-if="item.updatedAt"
                          > 
                              {{ new Date(item.updatedAt).toLocaleDateString("en-GB") }}
                          </span>
                        </template>
                        <template v-slot:item.missing_document="{ item }">
                            <span
                              text class="align-items--right"
                              min-width="200px"
                            >
                                <span class="missing-document-label" v-if="item.original_name === 'No Document' ">{{ getTranslation('Missing Document') }}</span>
                            </span>
                          </template>

                      </v-data-table>
                    </v-row>
                  </div>

                  <!-- V1-->
                  <!--<v-row v-if="phaseType == 'completion' || ( phaseType == 'all' && project.project_completion_document_list && project.project_completion_document_list.length !== 0)" > 
                        <span style="margin:auto;font-weight: bold;">{{ $t('Project Completion Document') }}</span>
                  </v-row> 
                  <v-row v-if="(form_type == 'addForm' || form_type == 'editForm') && phaseType == 'completion' "> 
                    <v-data-table style="margin:auto;"
                      class="v-data-table-document"
                      :headers="documentHeaders"
                      :items="project.project_completion_documents" 
                    >
                      <template v-for="header in documentHeaders" v-slot:[`header.${header.value}`]="{ header }">
                        <span>{{ getHeader(header.text) }}</span>
                      </template>
                      <template v-slot:item.document="{ item }">
                        <v-file-input
                          :label="item.name"
                          v-model="completionDocuments[item.id-1]"
                        >
                        <template slot="append">{{ project.project_completion_documents[item.id-1].original_name }}</template>
                        </v-file-input>
                      </template>
                      <template v-slot:item.updatetime="{ item }">
                          <span 
                            text class="align-items--right"
                            min-width="200px"
                            v-if="item.updatedAt"
                          > 
                              {{ new Date(item.updatedAt).toLocaleDateString("en-GB") }}
                          </span>
                        </template>
                        <template v-slot:item.missing_document="{ item }">
                            <span
                              text class="align-items--right"
                              min-width="200px"
                            >
                                <span class="missing-document-label" v-if="item.original_name === 'No Document' ">{{ getTranslation('Missing Document') }}</span>
                            </span>
                          </template>
                    </v-data-table>
                  </v-row> 

                  <v-row v-if="(form_type=='viewForm' && phaseType == 'completion') 
                                || (phaseType == 'all' && project.project_completion_document_list && project.project_completion_document_list.length !== 0)">
                    <v-data-table style="margin:auto;"
                      class="v-data-table-document"
                      :headers="documentHeaders"
                      :items="project.project_completion_documents" 
                    >
                      <template v-for="header in documentHeaders" v-slot:[`header.${header.value}`]="{ header }">
                        <span>{{ getHeader(header.text) }}</span>
                      </template>
                      <template v-slot:item.document="{ item }">
                        <span
                          text class="align-items--right"
                          min-width="200px"
                        > 
                            <span class="font-weight-black">{{ getTranslation(item.name) }} </span> : <span class="hyperlink_document" v-on:click="download(item.original_name, project.id, null)">{{ item.original_name }}</span>
                        </span>
                      </template>
                      <template v-slot:item.updatetime="{ item }">
                        <span
                          text class="align-items--right"
                          min-width="200px"
                          v-if="item.updatedAt"
                        > 
                            {{ new Date(item.updatedAt).toLocaleDateString("en-GB") }}
                        </span>
                      </template>
                      <template v-slot:item.missing_document="{ item }">
                          <span
                            text class="align-items--right"
                            min-width="200px"
                          >
                              <span class="missing-document-label" v-if="item.original_name === 'No Document' ">{{ getTranslation('Missing Document') }}</span>
                          </span>
                        </template>

                    </v-data-table>
                  </v-row>-->

                </v-container>
              </v-form>
            </material-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions v-if="form_type == 'addForm' || form_type == 'editForm'">
      <v-spacer></v-spacer>
      <v-btn
        class="close-button-fixed close-button"
        text
        v-on:click="close_edit()"
      >
        {{ $t('Close') }}
        <v-dialog v-model="dialog_modal_message" persistent max-width="800px" :retain-focus="false">
          <MessageAlert 
              v-if="dialog_modal_message" 
              :messageProps="$store.state.messages.close" 
              :cancelProps="$store.state.messages.no" 
              :validationProps="$store.state.messages.yes" 
              :dialog.sync="dialog_modal_message" 
              @answerModal="getModalAnswer"
          />
        </v-dialog>
      </v-btn>
      <v-btn
        class="save-button-fixed"
        color="white darken-1"
        style="background-color:#31c0be;"
        text
        v-on:click="save()"
        v-if="( (form_type == 'addForm' || form_type == 'editForm')
              && project.project_need_id
              && project.estimated_cost > 0
              && (!project.village_beneficiary_asset_vfm_number || (project.village_beneficiary_asset_vfm_number && project.village_beneficiary_asset_vfm_number >= 0) ) 
              && (!project.people_poverty_vfm_percent || (project.people_poverty_vfm_percent && project.people_poverty_vfm_percent >= 0) ) 
              && (!project.people_beneficiary_asset_vfm_number || (project.people_beneficiary_asset_vfm_number && project.people_beneficiary_asset_vfm_number >= 0) ) 
              && project.project_mark_id)
              && (phaseType !== 'planning_approval' || (phaseType == 'planning_approval' && 
                                                          (project.budget_number !== null && project.budget_number !== '') &&
                                                          (project.finance_sector_number !== null && project.finance_sector_number !== '') &&
                                                          (project.project_number !== null && project.project_number !== '') &&
                                                          (startDate < endDate) &&
                                                          (startPaymentDate < endPaymentDate)
                                                        )
                  )
              || phase_type == 'reporting'
              || phase_type == 'completion' "
      >
        {{ $t('Save') }}
      </v-btn>
    </v-card-actions>
    <v-card-actions v-if="form_type == 'viewForm'">
      <v-spacer></v-spacer>
      <v-btn
        class="close-button-fixed close-button"
        text
        v-on:click="close()"
      >
        {{ $t('Close') }}
      </v-btn>
      <v-btn class="update-button-fixed small" color="success" 
             v-on:click="update(project)" 
             v-if="(phase_type !=='all') && (project.project_status_id !== 6 && project.project_status_id !== 7) &&
             ($store.state.auth.user.user_functions[2].user_type_id !== 1
             || $store.state.auth.user.user_functions[4].user_type_id !== 1
             || $store.state.auth.user.user_functions[5].user_type_id !== 1
             || $store.state.auth.user.user_functions[8].user_type_id !== 1)">
        <v-icon>mdi-update</v-icon>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'ProjectDetailsForm',
    props: {
      projectProps: {
        type: Object
      },
      formType: {
        type: String
      },
      phaseType: {
        type: String
      }
    },
    data: () => ({
      dialog_modal_message: false,
      project: {},
      form_type: '',
      phase_type: '',
      projectOwner: {},
      projectOwnerSelected: '',
      //disasterSelected: '',
      needSelected: '',
      needSelectedName: '',
      projectNeedList: [],
      estimationCost: '',
      //assetSelected: '',
      startDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      endDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      startPaymentDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      endPaymentDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      evaluationDate: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      startDateMenu: false,
      endDateMenu: false,
      startPaymentDateMenu: false,
      endPaymentDateMenu: false,
      evaluationDateMenu: false,
      projectNeedInformation: [],
      projectClassInformation: [],
      needPictures: [],
      baselinePictures: [],
      reportingPictures: [],
      completionPictures: [],
      applicationDocuments: [],
      reportingDocuments: [],
      completionDocuments: [],
      dialog_add: false,
      dialog_view: false,
      display_create_new_reporting_button: false,
      display_create_completion_reporting_button: false,
      display_completion_reporting_container: false,
      documentHeaders: [
        {
          sortable: false,
          text: 'Document',
          align: 'center',
          value: 'document',
          width: '500px'
        },
        {
          sortable: false,
          text: 'Last Update',
          align: 'center',
          value: 'updatetime',
        },
        {
          sortable: false,
          text: 'Missing Document',
          align: 'center',
          value: 'missing_document',
        }
      ],
      fileRules: []
    }),
    computed: {
        /*dateRangeText () {
          return this.workDates.join(' until ')
        },*/
        projectSelected() {
          return this.$store.state.projects.projectSelected;
        },
        projectClassList() {
          return this.$store.state.referentials.projectClassList;
        }, 
        costCategoryList() {
          return this.$store.state.referentials.costCategoryList;
        }, 
        projectWorkTypeList() {
          return this.$store.state.referentials.projectWorkTypeList;
        },
        affectedAssetList() {
          return this.$store.state.referentials.affectedAssetList;
        },
        /*projectOwnerList() {
          return this.$store.state.projects.projectOwnerList;
        }, */  
        // ?????
        affectedAssetList() {
          return this.$store.state.projects.affectedAssetList;
        },  
        needs() {
          return this.$store.state.plans.needs;
        },  
        projectMarkList() {
          return this.$store.state.referentials.projectMarkList;
        },
        projectSelectedPlanPicture() {
          return this.$store.state.projects.projectSelectedPlanPicture;
        }, 
        projectSelectedApplicationPicture() {
          return this.$store.state.projects.projectSelectedApplicationPicture;
        }, 
        projectSelectedReportingPicture() {
          return this.$store.state.projects.projectSelectedReportingPicture;
        }, 
        projectSelectedCompletionPicture() {
          return this.$store.state.projects.projectSelectedCompletionPicture;
        }, 
    },
    created: function(){
      //https://v15.vuetifyjs.com/en/components/forms/ 
      this.nameRules = [ v => !!v || this.getTranslation('Name is required') ];
      this.numberRules = [ v => v > 0 || this.getTranslation('Positive Number is required') ];
      this.selectRules = [ v => !!v || this.getTranslation('At least 1 Information is required') ];
      this.dateRules = [ v => !!v || this.getTranslation('Date is required') ];
      this.dateOrderRules = [ v => this.startDate > this.endDate || this.getTranslation('Date Order')];
    },
    mounted: function(){
      if(this._props.formType !== 'addForm'){

        //console.log('this.projectProps', this.projectProps);

        //this.$store.dispatch('projects/getProjectApplicationPicture',{id: this.projectProps.id});
        //this.$store.dispatch('projects/getProjectReportingPicture',{id: this.projectProps.id});
        //this.$store.dispatch('projects/getProjectCompletionPicture',{id: this.projectProps.id});
        this.$store.dispatch('projects/getProjectPlanPicture', this.projectProps.project_need.project_need_pictures);
        this.$store.dispatch('projects/getProjectApplicationPicture', this.projectProps.baseline_pictures);
        this.$store.dispatch('projects/getProjectReportingPicture', this.projectProps.reporting_pictures);
        this.$store.dispatch('projects/getProjectCompletionPicture',this.projectProps.completion_pictures);
      }

      this.form_type = this.formType;
      this.phase_type = this.phaseType;
      this.project = this.projectProps;

      //console.log(this.project);

      //this.$store.dispatch('referentials/getProvinceList');
      //this.$store.dispatch('referentials/getDistrictList');
      //this.$store.dispatch('referentials/getVillageList');
      //this.$store.dispatch('disasters/getDisasters');
      //this.$store.dispatch('referentials/getProjectTypeList');
      //this.$store.dispatch('referentials/getProjectSectorList');
      this.$store.dispatch('referentials/getProjectClassList');
      this.$store.dispatch('referentials/getCostCategoryList');
      //this.$store.dispatch('referentials/getProjectWorkTypeList');
      //this.$store.dispatch('projects/getProjectOwnerList');
      this.$store.dispatch('plans/getNeeds');
      this.$store.dispatch('referentials/getProjectMarkList');

      //INSTRUCTION PHASE
      if(this._props.formType == 'addForm'){
        this.project.projectNeedInformation = this.projectNeedInformation;
        //Instruction Document
        this.project.project_instruction_documents = [];
        for (var i = 0; i < this.$store.state.referentials.instructionDocumentList.length;i ++) {

          //Management of the file array 
          var f = new File([""], "");
          this.applicationDocuments.push(f);

          //Management of the project object 
          this.project.project_instruction_documents.push({
            id: i+1,
            name: this.$store.state.referentials.instructionDocumentList[i].name,
            original_name: "No Document"
          });

        }

      }

      if(this._props.phaseType === 'reporting' && this.project.project_completion_document_list && this.project.project_completion_document_list.length !== 0){
        //console.log('**** completion ');
        this.phase_type = 'completion';
      }

    },
    destroyed(){
      this.project = {};
      if(this.phaseType == 'planning' || this.phaseType == 'planning_approval'){
        this.$store.dispatch('projects/getProjectListApplication');
      }else if(this.phaseType == 'reporting'){
        this.$store.dispatch('projects/getProjectOnGoingList');
      }else if(this.phaseType == 'completion'){
        //this.$store.dispatch('projects/getProjectCompletedList');
        this.$store.dispatch('projects/getProjectOnGoingList');
      }else{
        this.$store.dispatch('projects/getAllProjectList');
      }
      
    },
    watch: { 
      projectSelectedPlanPicture: function(value){
        if(this.$store.state.projects.projectSelectedPlanPicture.length < this.needPictures.length){

          const imageDeleted = this.needPictures.filter(img1 => !this.$store.state.projects.projectSelectedPlanPicture.some(img2 => img2[0].id === img1.id));
          const index = this.needPictures.indexOf(imageDeleted[0]);
          if (index > -1) {
              this.needPictures.splice(index, 1);
          }

        }else if(this.$store.state.projects.projectSelectedPlanPicture.length !== this.needPictures.length){

          this.needPictures.push({
            id: value[value.length-1][0].id,
            value: 'data:image/jpeg;base64,' + btoa(value[value.length-1][0].file.data.map(b => String.fromCharCode(b)).join(''))
          });
        }

      },
      projectSelectedApplicationPicture: function(value){
        //V1
        /*this.baselinePictures = [];
        for (var i = 0; i < value.length;i ++) {
          this.baselinePictures.push('data:image/jpeg;base64,' + btoa(value[i].file.data.map(b => String.fromCharCode(b)).join('')));
        }*/

        if(this.$store.state.projects.projectSelectedApplicationPicture.length < this.baselinePictures.length){

          const imageDeleted = this.baselinePictures.filter(img1 => !this.$store.state.projects.projectSelectedApplicationPicture.some(img2 => img2[0].id === img1.id));
          const index = this.baselinePictures.indexOf(imageDeleted[0]);
          if (index > -1) {
              this.baselinePictures.splice(index, 1);
          }

        }else if(this.$store.state.projects.projectSelectedApplicationPicture.length !== this.baselinePictures.length){

          this.baselinePictures.push({
            id: value[value.length-1][0].id,
            value: 'data:image/jpeg;base64,' + btoa(value[value.length-1][0].file.data.map(b => String.fromCharCode(b)).join(''))
          });
        }

      },
      projectSelectedReportingPicture: function(value){
        //V1
        /*this.reportingPictures = [];
        for (var i = 0; i < value.length;i ++) {
          this.reportingPictures.push('data:image/jpeg;base64,' + btoa(value[i].file.data.map(b => String.fromCharCode(b)).join('')));
        }*/

        if(this.$store.state.projects.projectSelectedReportingPicture.length < this.reportingPictures.length){

          const imageDeleted = this.reportingPictures.filter(img1 => !this.$store.state.projects.projectSelectedReportingPicture.some(img2 => img2[0].id === img1.id));
          const index = this.reportingPictures.indexOf(imageDeleted[0]);
          if (index > -1) {
              this.reportingPictures.splice(index, 1);
          }

        }else if(this.$store.state.projects.projectSelectedReportingPicture.length !== this.reportingPictures.length){

          this.reportingPictures.push({
            id: value[value.length-1][0].id,
            value: 'data:image/jpeg;base64,' + btoa(value[value.length-1][0].file.data.map(b => String.fromCharCode(b)).join(''))
          });
        }

      },
      projectSelectedCompletionPicture: function(value){
        //V1
        /*this.completionPictures = [];
        for (var i = 0; i < value.length;i ++) {
          this.completionPictures.push('data:image/jpeg;base64,' + btoa(value[i].file.data.map(b => String.fromCharCode(b)).join('')));
        }*/

        if(this.$store.state.projects.projectSelectedCompletionPicture.length < this.completionPictures.length){

          const imageDeleted = this.completionPictures.filter(img1 => !this.$store.state.projects.projectSelectedCompletionPicture.some(img2 => img2[0].id === img1.id));
          const index = this.completionPictures.indexOf(imageDeleted[0]);
          if (index > -1) {
              this.completionPictures.splice(index, 1);
          }

        }else if(this.$store.state.projects.projectSelectedCompletionPicture.length !== this.completionPictures.length){

          this.completionPictures.push({
            id: value[value.length-1][0].id,
            value: 'data:image/jpeg;base64,' + btoa(value[value.length-1][0].file.data.map(b => String.fromCharCode(b)).join(''))
          });
        }

      },
      estimationCost: function(value){
        this.project.estimated_cost = value;
        if(value/1000 < 20){
          this.projectClassInformation = this.projectClassList.filter(o => o.id === 5);
          this.project.project_class_id = 5;
        }else if(value/1000 >= 20 && value/1000 < 100){
          this.projectClassInformation = this.projectClassList.filter(o => o.id === 4);
          this.project.project_class_id = 4;
        }else if(value/1000 >= 100 && value/1000 < 200){
          this.projectClassInformation = this.projectClassList.filter(o => o.id === 3);
          this.project.project_class_id = 3;
        }else if(value/1000 >= 200 && value/1000 < 400){
          this.projectClassInformation = this.projectClassList.filter(o => o.id === 2);
          this.project.project_class_id = 2;
        }else{
          this.projectClassInformation = this.projectClassList.filter(o => o.id === 1);
          this.project.project_class_id = 1;
        }
      },
      needs: function(value){
        //Constrction of the need list without the need already used
        this.needs.forEach((need) => {

          if(need.projects.length === 0){
            this.projectNeedList.push(need);
          }else{
            var pushFlag = true;
            need.projects.forEach(function(project){

              //Take only need with all project rejected 
              if(project.project_status_id !== 5){
                pushFlag = false;
              }
            });

            if(pushFlag){
              this.projectNeedList.push(need);
            }
          }

        });
      },
      needSelected: function(value){

        this.project.project_need_id = value;
        this.project.projectNeedInformation = this.projectNeedList.filter(o => o.id === value);
        console.log('this.project.projectNeedInformation', this.project.projectNeedInformation);
        this.needSelectedName = this.project.projectNeedInformation[0].name_en;
        //this.needSelectedName = this.project.projectNeedInformation[0].project_type.translation.name 
        //    + ' - ' + this.project.projectNeedInformation[0].affected_asset_needs[0].affected_asset.asset_type.translation.name 
        //    + ': ' + this.project.projectNeedInformation[0].affected_asset_needs[0].affected_asset.affected_asset_number;
      }
    },
    methods: {
      getHeader(val) {
        return this.$t(val);
      },
      getTranslation(val) {
        return this.$t(val);
      },
      download: function(doc, project_id, project_reporting_id){

        var document_information = {
          document_name: doc,
          project_id: project_id
        }

        if(project_reporting_id !== null){
          document_information.project_reporting_id = project_reporting_id
        }

        if(doc !== 'No Document'){
          this.$store.dispatch('projects/downloadDocument', document_information);
        }

      },
      downloadPicture: function(img) {
        this.$store.dispatch('projects/downloadImg', img[0]);
      },
      downloadPlanDocument: function(doc) {
        this.$store.dispatch('plans/downloadPlanDocument', { id:doc.id });
      },
      deletePicture: function(img) {
        //console.log(img);
        this.$store.dispatch('projects/deleteImg', img[0]);
        //this.$store.dispatch('projects/deleteImg', img);
      },
      update: function(project){

        this.form_type = 'editForm';
        this.project = project;

        if(this.phaseType == 'planning' || this.phaseType == 'planning_approval'){

          //Add the need of the selected project in the list
          this.projectNeedList.push(this.needs.filter(o => o.id === project.project_need_id)[0]);

          this.estimationCost = project.estimated_cost;
          this.project.projectNeedInformation = this.projectNeedList.filter(o => o.id === project.project_need_id);
          this.needSelected = this.project.projectNeedInformation[0].id;
          this.needSelectedName = this.project.projectNeedInformation[0].name_en;
          /*this.needSelectedName = this.project.projectNeedInformation[0].project_type.translation.name 
            + ' - ' + this.project.projectNeedInformation[0].affected_asset_needs[0].affected_asset.asset_type.translation.name 
            + ': ' + this.project.projectNeedInformation[0].affected_asset_needs[0].affected_asset.affected_asset_number;*/
          

          if(project.project_start_date !== null){
            this.startDate = project.project_start_date.substring(0, project.project_start_date.indexOf('T'));
          }else{
            this.startDate = null;
          }
          if(project.project_end_date !== null){
            this.endDate = project.project_end_date.substring(0, project.project_end_date.indexOf('T'));
          }else{
            this.endDate = null;
          }
          
          if(project.payment_start_date !== null){
            this.startPaymentDate = project.payment_start_date.substring(0, project.payment_start_date.indexOf('T'));
          }else{
            this.startPaymentDate = null;
          }

          if(project.payment_end_date !== null){
            this.endPaymentDate = project.payment_end_date.substring(0, project.payment_end_date.indexOf('T'));
          }else{
            this.endPaymentDate = null;
          }

          if(project.evaluation_document_deadline !== null){
            this.evaluationDate = project.evaluation_document_deadline.substring(0, project.evaluation_document_deadline.indexOf('T'));
          }else{
            this.evaluationDate = null;
          }

          //Instruction Document
          for (var i = 0; i < this.project.project_instruction_documents.length;i ++) {
            var f = new File([""], "");
            this.applicationDocuments.push(f);
          }

        }

        if(this.phaseType == 'reporting'){
          for (var i = 0; i < this.$store.state.referentials.reportingDocumentList.length;i ++) {
            //Management of the file array 
            var f = new File([""], "");
            this.reportingDocuments.push(f);
          }

          //Management of the button create a new reporting V1
          /*if(this.project.project_reportings.length === 0 || this.project.project_reportings.length !== 0 && this.project.project_reportings[this.project.project_reportings.length-1].validated){
            this.display_create_new_reporting_button = true;
          }else{
            this.display_create_new_reporting_button = false;
          }*/
          //Management of the button create a new reporting V2
          if(this.project.project_reportings.length === 0 || this.project.project_reportings.length !== 0 && this.project.project_reportings.length < 3){
            this.display_create_new_reporting_button = true;
          }else{
            this.display_create_new_reporting_button = false;
          }
          if(this.project.project_reportings.length === 3){

            if(this.project.project_completion_document_list.length !== 0){
              this.display_completion_reporting_container = true;
              this.display_create_completion_reporting_button = false;
              this.phase_type = 'completion';
            }else{
              this.display_completion_reporting_container = false;
              this.display_create_completion_reporting_button = true;
            }

            for (var i = 0; i < this.$store.state.referentials.completionDocumentList.length;i ++) {
              //Management of the file array 
              var f = new File([""], "");
              this.completionDocuments.push(f);
            }
          }

        }

        //NOT USED ANYMORE
        if(this.phaseType == 'completion'){
          for (var i = 0; i < this.$store.state.referentials.completionDocumentList.length;i ++) {
            //Management of the file array 
            var f = new File([""], "");
            this.completionDocuments.push(f);
          }
        }

      },

      close: function(){
        this.form_type = 'viewForm';
        this.project = {};
        this.$emit('update:dialog', false)  
      },
      close_edit: function(){
        this.dialog_modal_message = true;
      },
      getModalAnswer(value){
        if(value){
          this.form_type = 'viewForm';
          this.project = {};
          this.$emit('update:dialog', false)  
        }
      },
      createNewReporting: function(){
        //console.log(this.project.project_reporting_documents);
        var nb = this.project.project_reporting_documents.length+1;

        if(this.project.project_reporting_documents.length !== 0){
          this.project.project_reporting_documents[this.project.project_reporting_documents.length-1].validated = true;
        }

        this.project.project_reporting_documents.push(
        {
          validated: false,
          name: 'ງວດ ' + nb,
          new_project_reporting: true,
          project_id: this.project.id,
          reporting_documents: []
        });

        for (var i = 0; i < this.$store.state.referentials.reportingDocumentList.length;i ++) {
            //Management of the file array 
            var f = new File([""], "");
            this.reportingDocuments.push(f);
            this.project.project_reporting_documents[nb-1].reporting_documents.push(
            {
              id: this.$store.state.referentials.reportingDocumentList[i].id,
              name: this.$store.state.referentials.reportingDocumentList[i].name,
              original_name: "No Document",
              document_category: {
                translation: {
                  name: this.$store.state.referentials.reportingDocumentList[i].name
                }
              }
            })
          }
          this.display_create_new_reporting_button = false;
      },
      createNewCompletionReporting: function(){

        this.project.project_reporting_documents[this.project.project_reporting_documents.length-1].validated = true;
        this.display_create_completion_reporting_button = false;
        this.display_completion_reporting_container = true;

        for (var i = 0; i < this.$store.state.referentials.completionDocumentList.length;i ++) {
          //Management of the file array 
          var f = new File([""], "");
          this.completionDocuments.push(f);
        }
        this.phase_type = 'completion';

      },
      save: function(){

        /********* ADD Phase *********/
        if(this.form_type == 'addForm'){

          if(!this.project.people_poverty_vfm_percent || this.project.people_poverty_vfm_percent < 0){
            this.project.people_poverty_vfm_percent = 0;
          }
          if(!this.project.people_beneficiary_asset_vfm_number || this.project.people_beneficiary_asset_vfm_number < 0){
            this.project.people_beneficiary_asset_vfm_number = 0;
          }
          if(!this.project.village_beneficiary_asset_vfm_number || this.project.village_beneficiary_asset_vfm_number < 0){
            this.project.village_beneficiary_asset_vfm_number = 0;
          }

          let project_baseline_pictures = new FormData();
          project_baseline_pictures.append("file", this.project.project_baseline_pictures);

          this.project.project_start_date = null;
          this.project.project_end_date = null;
          this.project.payment_start_date = null;
          this.project.payment_end_date = null;

          this.project.evaluation_document_deadline = this.evaluationDate;

          this.project.new_project_instruction_documents = [];

          let form = new FormData();

          //console.log('*****add project_instruction_documents',this.project.project_instruction_documents);

          for(var i=0; i < this.project.project_instruction_documents.length; i++){

            this.project.project_instruction_documents[i] = this.applicationDocuments[i];

            if(!this.project.project_instruction_documents[i].id){
              form.append("file", this.project.project_instruction_documents[i]);
              this.project.new_project_instruction_documents.push({
                'original_name': this.applicationDocuments[i].name
              });

            }else{
              this.project.new_project_instruction_documents.push({
                'original_name': "No Document"
              });
            }

          } 

          //console.log('*****add project',this.project);

          this.$store.dispatch('projects/addProject', this.project);
          //this.$store.dispatch('projects/getProjectListApplication');
        }

        /********* PLANNING Phase *********/
        if(this.form_type == 'editForm' && (this.phase_type == 'planning' || this.phase_type == 'planning_approval')){

          let project_baseline_pictures = new FormData();
          project_baseline_pictures.append("file", this.project.project_baseline_pictures);

          if(this.phase_type == 'planning_approval'){
            this.project.project_start_date = this.startDate;
            this.project.project_end_date = this.endDate;
            this.project.payment_start_date = this.startPaymentDate;
            this.project.payment_end_date = this.endPaymentDate;
          }else{
            this.project.project_start_date = null;
            this.project.project_end_date = null;
            this.project.payment_start_date = null;
            this.project.payment_end_date = null;
          }

          this.project.evaluation_document_deadline = this.evaluationDate;
          this.project.new_project_instruction_documents = [];

          let form = new FormData();

          //V1
          /*for(var i=0; i < this.project.project_instruction_documents.length; i++){

            form.append("file", this.project.project_instruction_documents[i]);

            if(!this.project.project_instruction_documents[i].id){
              this.project.new_project_instruction_documents.push({
                'original_name': this.project.project_instruction_documents[i].name
              });

            }else{
              this.project.new_project_instruction_documents.push({
                'original_name': "No Document"
              });
            }

          }*/

          //form.append("file", this.applicationDocuments);

          for(var i=0; i < this.applicationDocuments.length; i++){

            if(this.applicationDocuments[i] && this.applicationDocuments[i].name !== ""){

              this.project.project_instruction_documents[i] = this.applicationDocuments[i];

              form.append("file", this.project.project_instruction_documents[i]);

              this.project.new_project_instruction_documents.push({
                'original_name': this.applicationDocuments[i].name
              });

            }else{
              this.project.new_project_instruction_documents.push({
                'original_name': "No Document"
              });
            }

          }

          this.$store.dispatch('projects/updateProjectPlanningInformation',this.project);

          var requestParameter = {
            id : this.project.id,
            comments: this.project.comments
          }
          this.$store.dispatch('projects/updateProjectComments',requestParameter);
          //this.$store.dispatch('projects/getProjectListApplication');
        }

        /********* REPORTING Phase *********/
        if(this.phase_type == 'reporting'){

          let project_reporting_pictures = new FormData();
          project_reporting_pictures.append("file", this.project.project_reporting_pictures);

          let form = new FormData();
 
          //V1
          /*for(var i=0; i < this.project.project_reporting_documents.length; i++){

            if(!this.project.project_reporting_documents[i].validated){

              for (var j = 0; j < this.project.project_reporting_documents[i].reporting_documents.length;j++) {

                if(!this.project.project_reporting_documents[i].reporting_documents[j].id){
                  form.append("file", this.project.project_reporting_documents[i].reporting_documents[j]);
                }
              }

            }

          }*/

          for(var i=0; i < this.project.project_reporting_documents.length; i++){

            if(!this.project.project_reporting_documents[i].validated){

              for (var j = 0; j < this.reportingDocuments.length;j++) {

                //if(!this.project.project_reporting_documents[i].reporting_documents[j].id){
                if(this.reportingDocuments[j].name !== ""){

                  this.project.project_reporting_documents[i].reporting_documents[j] = this.reportingDocuments[j];
                  form.append("file", this.project.project_reporting_documents[i].reporting_documents[j]);

                }
              }

            }

          }

          //console.log('*****REPORTING this.project', this.project);
          
          this.$store.dispatch('projects/updateProjectReportingDocument',this.project);
          var requestParameter = {
            id : this.project.id,
            comments: this.project.comments
          }
          this.$store.dispatch('projects/updateProjectComments',requestParameter);

        }

        /********* COMPLETION Phase *********/
        if(this.phase_type == 'completion'){

          //console.log('*****REPORTING completion', this.project);

          let project_completion_pictures = new FormData();
          project_completion_pictures.append("file", this.project.project_completion_pictures);

          let form = new FormData();

          //V1
          /*for(var i=0; i < this.project.project_completion_documents.length; i++){

            if(!this.project.project_completion_documents[i].id){
              form.append("file", this.project.project_completion_documents[i]);
            }
          }*/

          for(var i=0; i < this.completionDocuments.length; i++){

            //if(!this.project.project_completion_documents[i].id){
            if(this.completionDocuments[i].name !== ""){

              this.project.project_completion_documents[i] = this.completionDocuments[i];
              form.append("file", this.project.project_completion_documents[i]);
            }
          }

          this.$store.dispatch('projects/updateProjectCompletionDocument',this.project);
          this.$store.dispatch('projects/updateVFMCompletion',this.project);
        }

        this.form_type = 'viewForm';
        this.$emit('update:dialog', false)  

      }
    }
  }
</script>
<style>
  v-btn {
    padding: 2px;
  }
  .v-picker {
    width: 210px;
    height: 300px;
  }
  .v-date-picker-header{
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .v-date-picker-header__value div {
    width: 100%;
  }
  .v-picker__title {
    padding: 7px;
  }
  .v-date-picker-title {
    align-items: center;
  }
  .v-date-picker-table--date th {
    padding: 0px;
  }
  .v-date-picker-table th {
    font-size: 10px;
  }
  .v-picker__body  {
    width: 150px;
    height: 100px;
  }
  div.v-picker__body, div.v-picker-header {
    width: 210px;
  }
  .v-picker__body > div {
      position: relative;
      right: 43px;
      width: 70%;
  }
  .v-picker__title__btn {
    font-size: 10px;
  }
  .v-date-picker-header__value {
    font-size: 10px;
    width: 150px;
  }
  .v-date-picker-table {
    width: 210px;
    padding: 0px;
    height: 100px;
  }
  .v-btn--icon.v-size--default {
    height: 30px;
    width: 30px;
}
.v-btn--icon.v-size--default .v-icon {
    height: 15px;
    font-size: 15px;
    width: 15px;
}
.v-date-picker-table--date .v-btn {
    height: 20px;
    width: 20px;
}
.v-date-picker-table .v-btn {
  font-size: 10px;
}
.v-data-table-document > .v-data-table__wrapper > table > thead > tr:last-child > th {
    width: 70%;
}
.hyperlink_document {
  cursor:pointer;
  text-decoration: underline;
}
.missing-document-label {
  font-weight: bold;
  color: orange;
}
.delete-button {
  position: relative;
  right: 30px;
  top: -8px;
  height: 10px;
  width: 10px;
}
.delete-button:hover {
  background-color: white !important;
}
.close-button-fixed {
    position: fixed;
    right: 195px;
    bottom: 53px;
}
.save-button-fixed {
    position: fixed;
    right: 115px;
    bottom: 53px;
}
.update-button-fixed {
    position: fixed;
    right: 115px;
    bottom: 53px;
}
.add-button-new-reporting {
  position: relative;
  color: white !important;
  background-color: #2196F3 !important;
  border-color: #2196F3 !important;
}
.add-button-new-reporting-container {
  display: flex;
  justify-content: space-around;
}

</style>
